module.exports = __webpack_public_path__ + "img/login-left-image.ab5b4fde.svg";